import api from "@/api/api";

export const getAssemblyConfig = (payload) => {
  return api.post("/upload/transloadit/assembly-config", payload);
};
